





















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import GenericEdit from "@/core/Generics/GenericEdit";
import RoleRequest from "../../models/security/roleRequest.model";
import { RoleRequestStatus } from "../../enums/RoleRequestStatus";
import { UserType } from "@/enums/UserType";
import RoleService from "@/services/role.service";
import Role from "../../models/security/role.model";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import pdfvuer from "pdfvuer";

@Component({
  components: {
    UserBasicInformationComponent,
    ResearchCenterBasicInformationComponent
  }
})
export default class RoleRequestViewAdmin extends GenericEdit<RoleRequest> {
  isModalChangeStatus = false;
  UserType = UserType;
  RoleRequestStatus = RoleRequestStatus;
  newStatus: RoleRequestStatus | null = null;
  changeStatusDescription = null;
  rolesChoosed: Array<Role> = [];
  roles = [];
  roleService = new RoleService();
  fondocyt = UserType.FONDOCYTUSER;


  constructor() {
    super();
    this.controller = "RoleRequest";
    this.model = new RoleRequest();
  }

  mounted() {
    
    this.getRoles();
  }

  getRoles() {
    this.roleService.getRoles().then((roles: any) => {
      this.roles = roles;
    });
  }
  
  goToRol() {
    this.$router.push(`/user/${this.model.userId}/roles`);
  }

  cancel() {
    this.$router.push(`${this.$router.currentRoute.path.split("/view")[0]}`);
  }

  approve() {
    this.newStatus = RoleRequestStatus.APPROVE;
    if (this.model.userType == UserType.FONDOCYTUSER) {
      this.isModalChangeStatus = true;
    } else {
      this.edit();
    }
  }

  decline() {
    this.newStatus = RoleRequestStatus.DECLINE;
    this.isModalChangeStatus = true;
  }

  protected async edit() {
    try {
      this.saving = true;
      this.model.roleRequestStatus = this.newStatus;
      this.model.descriptionChangeRequestStatus = this.changeStatusDescription;

      if (this.model.userType == UserType.FONDOCYTUSER) {
        this.model.rolesIds = this.rolesChoosed.map(x => x.id);
      }

      var result = await this.repository.update(this.id, this.model);
      this.saving = false;
      this.$emit("edit", result);
      this.clean();
      this.operationSuccess();
      this.isModalChangeStatus = false;
      this.getData();
    } catch (error) {
      var errors: any[] = [];
      if (Object.prototype.toString.call(error.data) === "[object String]") {
        errors.push(error.data);
      } else if (error.data && error.data.length > 0) {
        var errorMessages = error.data as any[];
        errorMessages.forEach(x => errors.push(x.errorMessage));
      } else {
        errors.push(error);
      }
      console.log(errors);
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }
}
